const chromeExtComposer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

export default chromeExtComposer;
